<template>
  <section class="content" v-if="page.ItemID">
    <div class="inner">
      <div class="col col-2 padded">
        <div v-html="page.main_text"></div>
        <div v-if="(isSuccess || isFailure)">
          <p v-if="!page.transaction_response">Please wait while we finalise your order...</p>
          <p v-if="page.transaction_response && page.transaction_response.message == 'OK'">
            Your payment was successful! Your order number is
            <strong>{{page.transaction_response.orderID}}</strong>. Confirmation has been emailed to you.
          </p>
          <p v-if="page.transaction_response && page.transaction_response.message != 'OK'">
            <span v-if="page.transaction_response.message == 'EmailError'">You will receive an email containing your order details, please contact us if it doesn't come through</span>
            <span v-else>{{page.transaction_response.details}}</span>
            <br>Your order number is 
            <strong>{{page.transaction_response.orderID}}</strong>
          </p>
        </div>
        <faqs-elem v-if="isFaqsPage"/>
        <testimonials-elem v-if="isTestimonialsPage"/>
      </div>
      <div class="col col-2 padded images" v-if="page.image || isContactPage">
        <img :alt="page.name" :src="page.image" class="product-img" v-if="page.image">
        <form-elem v-if="isContactPage"/>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"
import { mapGetters } from "vuex"

import FAQs from "./FAQs"
import TestimonialsElem from "./Testimonials"
import FormElem from "./Form"

export default {
  name: "Generic",
  components: { "faqs-elem": FAQs, TestimonialsElem, FormElem },
  computed: {
    ...mapState(["page"]),
    ...mapGetters(["isFaqsPage", "isTestimonialsPage", "isContactPage", "isSuccess", "isFailure"])
  }
}
</script>
